export const SET_MENU_OPEN = 'finto/mobileMenu/SET_MENU_OPEN';
export const SET_MENU_CLOSE = 'finto/mobileMenu/SET_MENU_CLOSE';
